import React from "react"
import {Rate as AntdRate} from "antd";
import {IFilterInput} from "../IFilterBase";
import {API_FILTER_TYPE} from "../../../model/constants/ApiConstant";
import IconBuilder from "../../IconBuilder";


interface IState {

}


interface IProps extends IFilterInput {
    onPressEnter?: () => void
    inputRef?: (node: HTMLInputElement) => void
}

class Rate extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {}
    }

    render() {
        const {field, onChange, onPressEnter, selected} = this.props


        const value = selected[0] ? selected[0].value : undefined

        return (
            <>
                <div className={'pb-2'} onKeyDown={e => e.key === 'Enter' ? onPressEnter?.() : undefined}>
                    <AntdRate value={value as number} count={field.options.rateLength}
                              character={field.options.rateIcon ? IconBuilder(field.options.rateIcon) : undefined}
                              onChange={result => result && onChange([{
                                  value: result,
                                  type: API_FILTER_TYPE.EQUAL,
                                  name: field.name
                              }])}/>
                </div>
            </>
        )
    }
}

export default Rate